<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card header="Detalhes">
          <b-col sm="6" lg="4">
              <b-row>
                <b-col sm="6">
                  <Callout variant="danger">
                    <small class="text-muted">próximos 10 dias</small><br>
                    <strong class="h4">Contas a Pagar</strong>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0">
          </b-col>
          <b-table class="mb-0 table-outline" 
            responsive="sm" 
            hover 
            :items="tableItems" 
            :fields="tableFields"
            head-variant="light">
           <!-- icone no header --> 
            <template v-slot:head(avatar)>
                <b-icon icon="person-fill" class="mr-1"></b-icon>
           </template>
           <!--icone nas linhas-->
            <template #cell(avatar)="data" >
              <b-icon icon="person-fill" v-bind:class="{ 'bg-info': data.value.status == 'info', 'bg-success': data.value.status == 'success',  'bg-warning': data.value.status == 'warning', 'bg-danger': data.value.status == 'danger', 'bg-secondary': data.value.status == '' }"></b-icon>
            </template>
            
            <template #cell(user)="data" >
              <div>
                <strong>{{data.value.name}}</strong>
              </div>
              <div class="small text-muted">
                <span>
                  Documento: {{data.value.registered}}
                </span>
                <span>
                  [{{data.value.parcela}}]
                </span>
              </div>
            </template>
            <i class="flag-icon flag-icon-pw h1" title="pw" id="pw"></i>
            <template #cell(usage)="data">
              <div class="clearfix">
                <div class="float-left">
                  <strong>{{data.value.valor}}</strong>
                  <strong>({{data.value.value}}%)</strong>
                </div>
                <div class="float-right">
                  <small class="text-muted">{{data.value.period}}</small>
                </div>
              </div>
              <b-progress height={} class="progress-xs" v-model="data.value.value" :variant="variant(data.value.value)"></b-progress>
            </template>
            <template #cell(activity)="data">
            <div class="small text-muted">Último Pagamento</div>
                <template v-if="data.value == '0'">
                  <strong>Sem Movimento</strong>
                </template>
                <template v-else>
                  <strong>{{data.value}} Dias Atrás</strong>
                </template>
            </template>
          </b-table>
          
        </b-card>
        <b-btn type="button" variant="primary" @click="$router.go(-1)" ><i class="fa fa-arrow-left"></i> Voltar</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Callout } from '../../components/'

export default {
  name: 'dashboard',
  components: {
    Callout
  },
  data: function () {
    return {
      tableItems: [
        {
          avatar: { url: '<i class="fa fa-arrow-left"></i>', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
          usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
          activity: '10 sec ago'
        }
      ],
      tableFields: [
        {
          key: 'avatar',
          label: '',
          class: 'text-center'
        },
        {
          key: 'user',
          label: 'Fornecedor'
        },
        {
          key: 'usage',
          label: 'Valor'
        },
        {
          key:'activity',
          label: 'Atividade'
        }
      ]
    }
  },
  methods: {
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    numberToReal (numero) {
      let n = numero.toFixed(2).split('.')
      n[0] = 'R$ ' + n[0].split(/(?=(?:...)*$)/).join('.')
      return n.join(',')
    },
    listarTitulos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/apagar/listartitulos10dias')
      let promise = this.$http.get(uri)
      this.tableItems = []
      promise.then((data) => {
        if (data) {
          let i
          /*
          let item = {
            avatar: { url: '', status: 'success' },
            user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
            usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
            activity: '10 sec ago'
          }
          */

          for (i = 0; i < data.data.length; i++) {
            this.tableItems.push({
              avatar: {url: '', status: this.variant(data.data[i].PERCENTUAL)},
              user: { name: data.data[i].NOME_CLIENTE, new: true, registered: data.data[i].DOCUMENTO, parcela: data.data[i].PARCELA },
              usage: { value: data.data[i].PERCENTUAL, valor: this.numberToReal(data.data[i].VALOR_ABERTO), period: new Date(data.data[i].DATA_INICIO).toISOString().substr(0, 10).split('-').reverse().join('/') + ' - ' + new Date(data.data[i].DATA_FIM).toISOString().substr(0, 10).split('-').reverse().join('/') },
              activity: data.data[i].ULT_BAIXA_DIAS == null ? '0' : data.data[i].ULT_BAIXA_DIAS
            })
            // titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          // this.areceber10DiasTitulos = titulos
        }
      })
    }
  },
  created () {
    this.listarTitulos10Dias()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/ApagarProximosDezDias.vue